import { infiniteQueryOptions } from "@tanstack/react-query";

import { queries } from "@/api/graphql/constants.ts";
import { GetNotificationsByUser } from "@/api/graphql/notifications/types.ts";
import { getNotificationsByUser } from "@/api/graphql/notifications/user/api.ts";
import { NotificationsMsSearchNotificationsRequestSortField } from "@/api/graphql/types/graphql.ts";
import { getNextPage } from "@/helpers/api/getNextPageParam/helper.ts";

export const createGetNotificationsByUserQueryOptions = (
  request: GetNotificationsByUser,
  queryFn: typeof getNotificationsByUser = getNotificationsByUser,
) =>
  infiniteQueryOptions({
    queryKey: [
      queries.GET_NOTIFICATIONS_BY_USER,
      request.userId,
      request.pageSize,
    ],
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) =>
      queryFn({
        filters: { userId: request.userId },
        paging: {
          page: pageParam,
          size: request.pageSize,
        },
        sorts: {
          field: NotificationsMsSearchNotificationsRequestSortField.CreatedTs,
          ascending: false,
        },
      }),
    getNextPageParam: (lastPage) => getNextPage(lastPage.pagination),
    enabled: Boolean(request.userId),
  });
